import QRCodeStyling from 'qr-code-styling';

import { EToasterStatus, showToast } from './showToast';

export interface DownloadQRCodeParams {
  deeplinkUrl: string;
  offerId: string;
  offerName: string;
}

export const downloadQRCode = async ({
  deeplinkUrl,
  offerId,
  offerName
}: DownloadQRCodeParams): Promise<void> => {
  try {
    const qrCode = new QRCodeStyling({
      width: 1024,
      height: 1024,
      type: 'canvas',
      data: deeplinkUrl,
      margin: 102,
      qrOptions: {
        errorCorrectionLevel: 'M'
      },
      dotsOptions: {
        color: '#000000', 
        type: 'rounded'
      },
      backgroundOptions: {
        color: 'transparent'
      },
      cornersSquareOptions: {
        color: '#000000',
        type: 'extra-rounded'
      },
      cornersDotOptions: {
        color: '#000000',
        type: 'dot'
      }
    });

    const rawData = await qrCode.getRawData('png');
    if (!rawData) {
      throw new Error('Failed to generate QR code');
    }

    const blob = rawData as Blob;

    const sanitizedName = offerName
      .replace(/[^a-z0-9]/gi, '-')
      .toLowerCase()
      .substring(0, 50);

    const filename = `checkout-link-${offerId}-${sanitizedName}.png`;

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    showToast({
      message: 'QR code downloaded successfully',
      status: EToasterStatus.SUCCESS
    });
  } catch (error) {
    console.error('Error generating QR code:', error);
    showToast({
      message: 'Failed to download QR code',
      status: EToasterStatus.ERROR
    });
  }
};

